/* PassPilot extras: Pass Pack offer card on result screens + funnel events for the pixels.
   Works alongside assets/pp-app.js without changing it. Events go out via Shopify.analytics.publish
   as "passpilot:<name>" and the Meta/TikTok custom pixels turn them into custom events. */
(function () {
  'use strict';
  var dataEl = document.getElementById('pp-data'), DATA = {};
  try { if (dataEl) DATA = JSON.parse(dataEl.textContent) || {}; } catch (e) { DATA = {}; }
  var BUY = (DATA.urls && DATA.urls.buy) || '/products/pass-pack';

  function lang() { var b = document.getElementById('pp-lang'); return b && b.textContent.trim() === 'EN' ? 'af' : 'en'; }
  function track(name, data) {
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        var p = a.publish('passpilot:' + name, Object.assign({ lang: lang(), page: location.pathname }, data || {}));
        if (p && p.catch) p.catch(function () {});
      }
    } catch (e) {}
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(s) { var m = String(s || '').match(/\d+/); return m ? Number(m[0]) : null; }

  /* Buy clicks anywhere on the site */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href !== BUY && href.indexOf('/products/pass-pack') < 0) return;
    var where = a.getAttribute('data-where') || (a.closest('#pp-status') ? 'status' : a.closest('.pp-sheet') ? 'sheet' : a.closest('.pp-result') ? 'result' : a.closest('.pp-nav') ? 'nav' : a.closest('.pp-footer') ? 'footer' : 'page');
    track('buy_click', { where: where });
    if (!(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && a.target !== '_blank' && e.button === 0) {
      e.preventDefault();
      setTimeout(function () { location.href = a.href; }, 200);
    }
  }, true);

  /* Trust strip under the header follows the app's EN/AF switch */
  function syncStrip() {
    var s = document.getElementById('pp-strip');
    if (!s) return;
    var L = lang();
    Array.prototype.forEach.call(s.querySelectorAll('[data-en]'), function (el) {
      var t = el.getAttribute('data-' + L) || el.getAttribute('data-en');
      if (el.textContent !== t) el.textContent = t;
    });
  }
  var langBtn = document.getElementById('pp-lang');
  if (langBtn) {
    syncStrip();
    new MutationObserver(syncStrip).observe(langBtn, { childList: true, characterData: true, subtree: true });
  }

  if (!dataEl) return;
  var scr = document.getElementById('pp-screen'), bd = document.getElementById('pp-backdrop');
  if (!scr) return;

  var OFFER = {
    en: { title: 'Unlock all {n} levels', body: 'Every road sign, every answer explained and unlimited mock tests.', btn: 'Get the Pass Pack · {price}', note: 'Once-off, no debit order · 5-day money-back · Secure Paystack checkout, debit cards work' },
    af: { title: 'Sluit al {n} vlakke oop', body: 'Elke padteken, elke antwoord verduidelik, en soveel oefentoetse as wat jy wil.', btn: 'Kry die Pass Pack · {price}', note: 'Een keer betaal, geen debietorder nie · 5 dae geld terug · Veilig betaal via Paystack, debietkaarte werk' }
  };
  function specialText() {
    if (!(DATA.special && DATA.was)) return '';
    return lang() === 'af' ? DATA.special.af + ': nou ' + DATA.price + ' (was ' + DATA.was + '), ' + DATA.special.untilAf
                           : DATA.special.en + ': ' + DATA.price + ' instead of ' + DATA.was + ', ' + DATA.special.untilEn;
  }
  var nLevels = (DATA.levels || []).filter(function (l) { return l.tier === 'free' || l.tier === 'paid'; }).length;
  var tip = (DATA.img && DATA.img.tip) || '';

  try {
    var st = document.createElement('style');
    st.textContent = '.pp-offer{margin:18px 0 6px;padding:16px;border-radius:20px;background:#FFF7DB;border:2px solid #FFC629;text-align:left;display:grid;grid-template-columns:56px 1fr;gap:6px 12px;align-items:center}' +
      '.pp-offer img{width:56px;height:auto}.pp-offer-t b{display:block;font:800 20px/1.15 "Baloo 2",sans-serif;color:#10324F}' +
      '.pp-offer-t span{display:block;font-size:14px;line-height:1.35;color:#3D5568}.pp-offer .pp-btn{grid-column:1/-1;margin-top:8px}' +
      '.pp-offer small{grid-column:1/-1;text-align:center;color:#3D5568;font-size:13px}' +
      '.pp-offer .pp-offer-sp{grid-column:1/-1;text-align:center;font-weight:800;color:#B3261E;font-size:14px}.pp-offer-sp s,.pp-sheet .pp-was{color:#6B8AA5;font-weight:700;margin-left:6px}' +
      '.pp-lead{margin:12px 0 6px;padding:16px;border-radius:20px;background:#fff;border:2px dashed #BFD8EC;text-align:left;display:grid;gap:8px}' +
      '.pp-lead b{font:800 19px/1.15 "Baloo 2",sans-serif;color:#10324F}.pp-lead p{margin:0;font-size:14px;line-height:1.4;color:#3D5568}' +
      '.pp-lead form{display:grid;gap:8px}.pp-lead input{width:100%;box-sizing:border-box;font:700 16px Nunito,sans-serif;padding:12px 14px;border:2px solid #DDEBF6;border-radius:14px;color:#10324F}' +
      '.pp-lead .pp-lead-x{color:#6B8AA5;font-size:13px;text-align:center;cursor:pointer;text-decoration:underline}.pp-lead[hidden]{display:none}';
    document.head.appendChild(st);
  } catch (e) {}

  function offerCard(where) {
    var o = OFFER[lang()] || OFFER.en, d = document.createElement('div');
    d.className = 'pp-offer';
    d.innerHTML = (tip ? '<img src="' + esc(tip) + '" alt="">' : '<span></span>') +
      '<div class="pp-offer-t"><b>' + esc(o.title.replace('{n}', nLevels)) + '</b><span>' + esc(o.body) + '</span></div>' +
      '<a class="pp-btn pp-btn-block" href="' + esc(BUY) + '" data-where="' + esc(where) + '">' + esc(o.btn.replace('{price}', DATA.price || 'R99')) + '</a>' +
      (specialText() ? '<span class="pp-offer-sp">' + esc(specialText()) + '</span>' : '') +
      '<small>' + esc(o.note) + '</small>';
    return d;
  }

  /* Email capture ("study plan") for visitors who are not ready to buy. Posts the hidden Shopify customer form. */
  var LEAD = {
    en: { title: 'Not ready yet? Get a free 7-day study plan', body: "We'll email you a day-by-day plan for the computer learner's test, plus tips and our specials. Unsubscribe anytime.", btn: 'Email me the plan', ph: 'Your email address', ok: 'Done! Check your inbox (and spam folder) for your study plan.', bad: 'Please check your email address.', no: 'No thanks' },
    af: { title: 'Nog nie heeltemal reg nie? Kry gratis \'n 7-dae-studieplan', body: "Ons stuur vir jou 'n plan vir elke dag tot jy jou learner's skryf, plus wenke en ons specials. Jy kan enige tyd uitteken.", btn: 'Stuur my die plan', ph: 'Jou e-posadres', ok: 'Klaar! Kyk in jou inbox (en spam) vir jou studieplan.', bad: 'Kyk gou weer na jou e-posadres.', no: 'Nee dankie' }
  };
  function leadDone() { try { return localStorage.getItem('pp-lead-done') === '1'; } catch (e) { return false; } }
  var leadWrap = document.getElementById('pp-lead-form'), leadForm = document.getElementById('pp-lead'), leadWhere = 'result', leadClosed = false;
  /* The real Shopify customer form (rendered by Liquid, so Shopify's spam check works) is moved into the result screen. */
  function buildLead() {
    if (!leadWrap || !leadForm || leadWrap.getAttribute('data-ppx')) return;
    leadWrap.setAttribute('data-ppx', '1');
    leadWrap.className = 'pp-lead';
    var head = document.createElement('div');
    head.innerHTML = '<b class="pp-lead-t"></b><p class="pp-lead-p"></p>';
    leadWrap.insertBefore(head, leadForm);
    var inp = leadForm.querySelector('input[name="contact[email]"]');
    inp.required = true; inp.setAttribute('inputmode', 'email');
    var btn = document.createElement('button'); btn.type = 'submit'; btn.className = 'pp-btn pp-btn-navy pp-btn-block pp-lead-b';
    leadForm.appendChild(btn);
    var x = document.createElement('small'); x.className = 'pp-lead-x'; x.setAttribute('role', 'button'); x.tabIndex = 0;
    x.onclick = function () { leadClosed = true; leadWrap.hidden = true; };
    leadWrap.appendChild(x);
    leadForm.addEventListener('submit', function () {
      var t = leadForm.querySelector('input[name="contact[tags]"]');
      if (t) t.value = 'lead,practice,' + leadWhere + ',' + lang();
      try { localStorage.setItem('pp-lead-pending', '1'); } catch (e) {}
      try { localStorage.setItem('pp-lead-where', leadWhere); } catch (e) {}
      track('lead_try', { where: leadWhere });
    });
  }
  function showLead(where, anchor) {
    buildLead();
    if (!leadWrap || !anchor || !anchor.parentNode) return;
    var L = LEAD[lang()] || LEAD.en;
    leadWhere = where;
    leadWrap.querySelector('.pp-lead-t').textContent = L.title;
    leadWrap.querySelector('.pp-lead-p').textContent = L.body;
    leadWrap.querySelector('.pp-lead-b').textContent = L.btn;
    leadWrap.querySelector('.pp-lead-x').textContent = L.no;
    leadForm.querySelector('input[name="contact[email]"]').placeholder = L.ph;
    anchor.parentNode.insertBefore(leadWrap, anchor);
    leadWrap.hidden = false;
  }
  /* Back from Shopify after signing up: say thanks */
  if (/[?&]customer_posted=true/.test(location.search)) {
    /* Shopify accepted the sign-up: count the lead once (the pixels send it to Meta as Lead and to TikTok as SubmitForm) */
    var ppWasPending = false, ppWhere = 'result';
    try { ppWasPending = localStorage.getItem('pp-lead-pending') === '1'; ppWhere = localStorage.getItem('pp-lead-where') || 'result'; } catch (e) {}
    if (ppWasPending) track('lead_submit', { where: ppWhere });
    try { localStorage.setItem('pp-lead-done', '1'); localStorage.removeItem('pp-lead-pending'); } catch (e) {}
    var Lk = LEAD[lang()] || LEAD.en, toast = document.createElement('div');
    toast.textContent = Lk.ok;
    toast.style.cssText = 'position:fixed;left:12px;right:12px;top:12px;z-index:90;max-width:520px;margin:0 auto;background:#17804A;color:#fff;font:800 15px/1.4 Nunito,sans-serif;padding:14px 16px;border-radius:16px;box-shadow:0 8px 24px rgba(16,50,79,.25)';
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 7000);
  }

  function onResult(inner) {
    var kind = scr.querySelector('#pp-again') ? 'level' : scr.querySelector('.pp-sections') ? 'mock' : scr.querySelector('.pp-share') ? 'daily' : 'drill';
    var d = {}, score = scr.querySelector('.pp-score'), stat = scr.querySelector('.pp-stats b');
    if (kind === 'level') {
      var stars = scr.querySelector('.pp-bigstars'), img = scr.querySelector('img.pp-result-stars');
      d.level = num((scr.querySelector('.pp-sub') || {}).textContent);
      d.stars = stars ? num(stars.getAttribute('aria-label')) : (img ? 3 : null);
      if (stat) { var p = stat.textContent.split('/'); d.correct = num(p[0]); d.total = num(p[1]); }
    } else if (kind === 'daily') {
      if (score) d.correct = num(score.textContent);
      d.total = 5;
    } else if (kind === 'mock') {
      if (score) d.pct = num(score.textContent);
    }
    track(kind + '_complete', d);
    if (DATA.access || kind === 'drill') return;
    if (kind === 'level' || kind === 'daily') {
      var anchor = kind === 'level' ? scr.querySelector('#pp-to-map') : scr.querySelector('.pp-share');
      if (anchor && anchor.parentNode && !inner.querySelector('.pp-offer')) anchor.parentNode.insertBefore(offerCard(kind), anchor);
    }
    if (!DATA.customer && !leadDone() && !leadClosed && leadForm) {
      showLead(kind, scr.querySelector(kind === 'daily' ? '.pp-share' : '#pp-to-map'));
    }
    track('offer_view', { where: kind });
  }

  function onQuestion(inner) {
    var c = scr.querySelector('.pp-count');
    if (!c || !/^1\//.test(c.textContent.trim())) return;
    var meta = (scr.querySelector('.pp-playmeta') || {}).textContent || '';
    var kind = /Daily 5|Daaglikse 5/.test(meta) ? 'daily' : /mock|oefentoets/i.test(meta) ? 'mock' : /mistake|fout/i.test(meta) ? 'drill' : 'level';
    track('play_start', { kind: kind, level: kind === 'level' ? num(meta) : null });
  }

  function check() {
    if (scr.hidden) return;
    var inner = scr.querySelector('.pp-screen-inner');
    if (!inner || inner.getAttribute('data-ppx')) return;
    inner.setAttribute('data-ppx', '1');
    if (scr.classList.contains('result')) onResult(inner); else onQuestion(inner);
  }
  new MutationObserver(check).observe(scr, { childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });

  if (bd) {
    new MutationObserver(function () {
      if (bd.hidden) return;
      var sheet = bd.querySelector('.pp-sheet');
      if (!sheet || sheet.getAttribute('data-ppx') || !sheet.querySelector('.pp-price')) return;
      sheet.setAttribute('data-ppx', '1');
      if (DATA.was) {
        var pb = sheet.querySelector('.pp-price b');
        if (pb && !sheet.querySelector('.pp-was')) { var w = document.createElement('s'); w.className = 'pp-was'; w.textContent = DATA.was; pb.parentNode.insertBefore(w, pb.nextSibling); }
        if (specialText() && !sheet.querySelector('.pp-offer-sp')) { var sp = document.createElement('p'); sp.className = 'pp-offer-sp'; sp.style.cssText = 'margin:6px 0 0;font-weight:800;color:#B3261E;font-size:14px'; sp.textContent = specialText(); var pr = sheet.querySelector('.pp-price'); if (pr) pr.parentNode.insertBefore(sp, pr.nextSibling); }
      }
      track('offer_view', { where: 'sheet' });
    }).observe(bd, { childList: true, attributes: true, attributeFilter: ['hidden'] });
  }
})();